import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAccess } from "../../hooks/useAccess";
import { icons } from "../../icons/IconSet";
import RotateIcon from "../common/RotateIcon";
import { INavItem } from "./INav";
import SideBarNavLink from "./SideBarNavLink";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getCurrentUser } from "../../store/authSlice";

const SideBarNav: FC = () => {
  const { getPageAccess } = useAccess();
  const { pathname } = useLocation();
  const user = useTypedSelector(getCurrentUser());
  
  const filterNav = (nav: INavItem[]): INavItem[] =>
    nav.reduce((acc, item) => {
      if (item?.isNotAvailable || !item?.name) return acc;
      if (!item?.children?.length) return [...acc, item];
      
      const children = filterNav(item.children);
      if (children?.length) return [
        ...acc,
        {
          ...item,
          children 
        }
      ];
      return acc;
    }, [] as INavItem[]);

  const nav: INavItem[] = filterNav([
    // { name: 'Dashboard', to: '/dashboard', isNotAvailable: !getPageAccess('/dashboard') },
    // { name: 'User Service', children: [
      { name: 'Account', to: `/account`, isNotAvailable: !getPageAccess('/account') },
    // ]},    
    { name: 'Admin Service', children: [
      { name: 'Users', to: '/users', isNotAvailable: !getPageAccess('/users') },
      { name: 'New User', to: '/users/new', isNotAvailable: !getPageAccess('/users/new') },
      { name: 'Vendors', to: '/vendors', isNotAvailable: !getPageAccess('/vendors') },
      { name: 'New Vendor', to: '/vendors/new', isNotAvailable: !getPageAccess('/vendors/new') },
    ]},
  ]);

  const [openedNavsIndxs, setOpenedNavsIndxs] = useState<Record<string, boolean>>(nav.reduce((acc, { children }, i) => ({
    ...acc,
    [i]: !!children?.length
  }), {} as Record<string, boolean>)); 

  return (
    <nav className="flex flex-1 flex-col gap-4">
      {nav.map(({ name, children, to, onClick }, i) => children?.length
        ? (
          <div key={`${name}-${i}`} className=" overflow-hidden">
            <div
              className="text-text_pale px-2 flex justify-between cursor-pointer"
              tabIndex={-1}
              role="button"
              onClick={() => setOpenedNavsIndxs((prevState) => ({
                ...prevState,
                [i]: !prevState?.[i],
              }))}
            >
              {name}
              <RotateIcon isShown={openedNavsIndxs?.[i]}>
                {icons('chevron-down', { width: '16px' })}
              </RotateIcon>
            </div>
            <div className={`transition-all duration-300
              ${openedNavsIndxs?.[i]
                ? 'opacity-100 translate-y-1 h-auto'
                : 'opacity-0 -translate-y-0 h-0'}
            `}>
              {children.map((child, j) => !child?.to || child?.disabled
                ? <div
                    key={`${child?.name}-${j}`}
                    className="block py-[6px] px-4 opacity-50"
                  >
                    {child?.name}
                  </div>
                : (
                  <SideBarNavLink
                    key={`${child?.to}-${child?.name}`}
                    to={child?.to}
                    // isCurrent={isCurrentPath(pathname, child?.to) && !children.find(({ to }) => to === child?.to) && pathname !== child?.to}
                    isCurrent={child.isCurrent || pathname === child?.to}
                  >
                    {child?.name || '-'}
                  </SideBarNavLink>
              ))}
            </div>
          </div>            
        ) : (
          !to
            ? <div className="">{name}</div>
            : (
              <SideBarNavLink key={`${to}-${name}`} to={to}>
                {name || '-'}
              </SideBarNavLink>
            )
        )
      )}
    </nav>
  );
}

export default SideBarNav;
